import { createStore, applyMiddleware , compose } from 'redux';
import reducers from '../reducers';
import promise from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

const loggerMiddleware = createLogger();


function reduxStore(initialState) {
  //const store = createStore(reducers, initialState ,applyMiddleware(thunkMiddleware));

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(reducers, initialState, composeEnhancers(
    applyMiddleware(loggerMiddleware,thunkMiddleware, promise())
  ));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // We need to require for hot reloading to work properly.
      const nextReducer = require('../reducers');  // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default reduxStore;



// WEBPACK FOOTER //
// ./stores/index.js